export type PublitioPlayerSource = {
  poster?: string;
  src: string;
};

function extractAttribute(tag: string, attribute: string): string | undefined {
  const match = tag.match(
    new RegExp(`${attribute}\\s*=\\s*["']([^"']+)["']`, "i"),
  );

  return match?.[1]?.trim() || undefined;
}

function extractSourceTags(sourceHtml: string) {
  return Array.from(sourceHtml.matchAll(/<source\b[^>]*>/gi))
    .map((match) => {
      const tag = match[0];

      return {
        src: extractAttribute(tag, "src") ?? "",
        type: extractAttribute(tag, "type") ?? "",
      };
    })
    .filter((source) => source.src.length > 0);
}

function extractInlineVideoSource(sourceHtml: string): string | undefined {
  const patterns = [
    /loadSource\((["'])(.*?)\1\)/i,
    /\.src\s*=\s*(["'])(.*?)\1/i,
    /source\s*:\s*(["'])(.*?)\1/i,
  ];

  for (const pattern of patterns) {
    const match = sourceHtml.match(pattern);

    if (match?.[2]?.trim()) {
      return match[2].trim();
    }
  }

  return undefined;
}

export function parsePublitioSourceHtml(
  sourceHtml: string,
): PublitioPlayerSource | null {
  const videoTag = sourceHtml.match(/<video\b[^>]*>/i)?.[0];

  if (!videoTag) {
    return null;
  }

  const poster = extractAttribute(videoTag, "poster");
  const sources = extractSourceTags(sourceHtml);
  const prioritizedSource =
    sources.find(
      (source) =>
        source.type.toLowerCase().includes("mpegurl") ||
        source.src.toLowerCase().includes(".m3u8"),
    ) ?? sources[0];

  const src =
    prioritizedSource?.src ||
    extractAttribute(videoTag, "src") ||
    extractInlineVideoSource(sourceHtml);

  if (!src) {
    return null;
  }

  return { poster, src };
}
